import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { IRepository } from './repository';
import { DocumentNode } from 'graphql';
import { EntityLogInfo } from './logs/entity-log-info';

export abstract class BaseRepository<T> implements IRepository<T> {
  constructor(protected apollo: Apollo, protected fragment: DocumentNode) {}

  abstract get(id: string): Observable<T>;

  abstract getAll(): Observable<T[]>;

  abstract create(data: Partial<T>, logInfo: EntityLogInfo): Observable<Partial<T>>;

  abstract update(data: Partial<T>, logInfo: EntityLogInfo): Observable<Partial<T>>;

  abstract delete(id: string, logInfo: EntityLogInfo): Observable<boolean>;
}
